/*@ngInject*/
const ValidateAccountRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.validateAccount = function (accountId) {
        let url = '/rest/Account/' + accountId + '/validateAccount';

        return this.post(url);
    };
};

angular.module('gw-um-submission')
    .service('validateAccountRepository', ValidateAccountRepository);
